import React, { useEffect, useState } from "react";
import { BasketItem } from "../../../models/BasketItem";
import "../style/basketTableStyle.scss";
import "../../../../style/block.scss";
import "../../../../style/feature.scss";
import "./basketItem.scss";
import { HiOutlineTicket, HiOutlineX } from "react-icons/hi";
import { BiIdCard, BiPurchaseTagAlt } from "react-icons/bi";
import { BsPiggyBank } from "react-icons/bs";
import { TicketAccess } from "../../../models/TicketAccess";
import useFacility from "../../../../utils/hooks/useFacility";
import { useTranslation } from "react-i18next";
import EAIconButton from "../../shared/Buttons/EAIconButton";
import EAQuantitySelector from "../../shared/QuantitySelector/EAQuantitySelector";
import { format } from "date-fns";
import useTabletSize from "../../../../utils/hooks/useTabletSize";
import useHideTimeFromExercises from "../../../../utils/hooks/useHideTimeFromExercises";

interface IProps {
  item: BasketItem;
  index: number;
  refreshBasket: Function;
  onRemoveBasket: (index: number) => void;
  handleGetBasket: Function;
  handleAddBasket: (
    assortIds: string,
    assortName: string,
    price: number,
    ticketAccess: TicketAccess | any,
    validFrom: string | null,
    qnt: number | 1,
  ) => void;
  isLoading: boolean;
  hideExerciseInfo?: boolean;
}

const BasketListItem: React.FC<IProps> = ({
  item,
  index,
  onRemoveBasket,
  handleAddBasket,
  handleGetBasket,
  refreshBasket,
  isLoading,
  hideExerciseInfo,
}: IProps) => {
  const { t } = useTranslation();
  const facilityIds = useFacility();
  const hideTimeFromExercises = useHideTimeFromExercises();
  const [plusAssort, setPlusAssort] = useState<boolean>(true);
  const [minusAssort, setMinusAssort] = useState<boolean>(true);
  const [deleteAssort, setDeleteAssort] = useState<boolean>(true);
  const isDiscount = item.price !== item.listPrice;
  const isTablet = useTabletSize();

  // tutaj juz mam asortname wiec tu zrobimy walidacje

  useEffect(() => {
    if (facilityIds === "1220") {
      if (item.assortName === "OPIEKUN OS. Z NIEPEŁNOSPRAWNOŚCIĄ int.") {
        setPlusAssort(false);
        setMinusAssort(true);
      }
      // setAdditionalAsortName("PRZEWODNIK");
    }
    if (facilityIds === "1220") {
      if (item.assortName === "BILET OPIEKUN GRUPY INT.") {
        setPlusAssort(false);
        setMinusAssort(false);
        setDeleteAssort(false);
      }
      // setAdditionalAsortName("PRZEWODNIK");
    }
    if (facilityIds === "1224") {
      if (item.assortName === "BILET GRATISOWY") {
        setPlusAssort(false);
        setDeleteAssort(false);
        setMinusAssort(true);
      }
      // setAdditionalAsortName("PRZEWODNIK");
    }
    // if (facilityIds === "1214" || facilityIds === "1213" || facilityIds === "1230") {
    //   if (item.assortName === "Opłata internetowa") {
    //     setPlusAssort(false);
    //     setMinusAssort(false);
    //   }
    // }
    if (item.qb_card) {
      setPlusAssort(false);
      setMinusAssort(false);
    }
    if (item.assortName === "Opłata internetowa") {
      setPlusAssort(false);
      setMinusAssort(false);
      setDeleteAssort(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityIds]);

  useEffect(() => {
    if (facilityIds === "1228") {
      if (
        item.assortName === "Opiekun Wystawa" ||
        item.assortName === "Opiekun Pracownie" ||
        item.assortName === "Opiekun Edukator" ||
        item.assortName === "Pracownie - lab przedszkolaka opiekun"
      ) {
        setPlusAssort(false);
        setMinusAssort(false);
        setDeleteAssort(false);
      }
      if (
        item.assortName === "Asystent Wystawa" ||
        item.assortName === "Asystent Laboratorium" ||
        item.assortName === "Asystent Edukator"
      ) {
        setPlusAssort(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item]);

  return (
    <>
      <div className="basket-list-item flex-between-center">
        <div className="basket-list-item-icon">
          {item.qb_card ? (
            <b className="discount-qb">%</b>
          ) : (
            <>
              {" "}
              {item.ticket === true && <HiOutlineTicket className="icon" />}
              {item.pass === true && <BiIdCard className="icon" />}
              {item.service === true && <BiPurchaseTagAlt className="icon" />}
              {item.accountIncome === true && <BsPiggyBank className="icon" />}
              {item.assortName === "Opłata internetowa" && <BsPiggyBank className="icon" />}
            </>
          )}
        </div>

        <div className="basket-list-item-text">
          <b>{String(item.assortName)}</b>
          {!hideExerciseInfo && item.ticketAccess && item.ticketAccess[0] && (
            <>
              <span>
                {item.ticketAccess[0].exerciseName} | {format(new Date(item.ticketAccess[0].startDate), "yyyy-MM-dd")}
                {!hideTimeFromExercises && (
                  <b> {format(new Date(item.ticketAccess[0].startDate), "HH:mm")}</b>
                )}
              </span>
            </>
          )}
        </div>

        <b className="basket-list-item-price">
          <b className={`price ${isDiscount ? "price-through" : ""}`}>
            {item.listPrice.toFixed(2)} {t("zl")}
          </b>
          {isDiscount && (
            <b className={`price ${isDiscount ? "price-through-color" : ""}`}>
              {item.price.toFixed(2)} {t("zl")}
            </b>
          )}
        </b>

        <div className="basket-list-item-quantity">
          <EAQuantitySelector
            value={item.qnt}
            onChange={() => {}}
            onIncrement={() => {
              if (isLoading) {
                return;
              }
              handleAddBasket(item.assortIds, item.assortName, item.price, item.ticketAccess, null, 1);
            }}
            onDecrement={() => {
              if (isLoading) {
                return;
              }
              if (item.qnt === item.minSale) {
                onRemoveBasket(index);
              } else {
                handleAddBasket(item.assortIds, item.assortName, item.price, item.ticketAccess, null, -1);
              }
            }}
            disabled={true}
            incrementDisabled={!plusAssort || isLoading}
            decrementDisabled={!minusAssort || isLoading}
            min={0}
            max={99}
            compact={isTablet}
          />
        </div>

        <b className="basket-list-item-price-total">
          {(item.price * item.qnt).toFixed(2)} {t("zl")}
        </b>

        <>
          <EAIconButton
            title="Usuń z koszyka"
            icon={<HiOutlineX />}
            disabled={!deleteAssort || isLoading}
            onClick={() => onRemoveBasket(index)}
            variant="icon"
            color="secondary"
          />
        </>
      </div>
    </>
  );
};

export default BasketListItem;
